import React from 'react'
import { Nav, NavItem, Glyphicon } from 'react-bootstrap'
import { browserHistory } from 'react-router'

import { isMobile } from '../lib/AppTools'
import { getText } from '../lib/text.js'

const go = (x) => browserHistory.push(`/private/${x}`)

type Props = {
  active : string
}

const AdminNav = ({ active } = Props) => (
  !isMobile() ? (
    <Nav 
      bsStyle="tabs" 
      activeKey={active}
      onSelect={(k) => go(k)} 
    >
      <NavItem eventKey={"blocks"}>{getText("Plantillas")}</NavItem>
      <NavItem eventKey={"expenses"}>{getText("Plantillas de gasto")}</NavItem>
      <NavItem eventKey={"activities"}>{getText("Actividades")}</NavItem>
      <NavItem eventKey={"cities"}>{getText("Ciudades")}</NavItem>
      <NavItem eventKey={"suppliers"}>{getText("Proveedores")}</NavItem>
      <NavItem eventKey={"users"}>{getText("Usuarios")}</NavItem>
      <NavItem eventKey={"products"}>{getText("ZhangShang")}</NavItem>
    </Nav>
  )
  : (
    null
  )
)

export default AdminNav
